import React, { useState, useEffect } from "react";
import "./landingPage.css";
import { Breadcrumb, Card, Row, Col, Statistic, Spin } from "antd";
import CountUp from "react-countup";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import {
  UserOutlined,
  VideoCameraOutlined,
  SmileOutlined,
  BookOutlined,
} from "@ant-design/icons";

const Dashboard = () => {
  const [clientCount, setClientCount] = useState(0);
  const [subClientCount, setSubClientCount] = useState(0);
  const [numbersCount, setNumbersCount] = useState(0);
  const [messageCount, setMessageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getAppStats = async () => {
    let getRes = (res) => {
      console.log("Resss...........", res);
      setTimeout(() => {
        setClientCount(res?.data?.totalClients);
        setSubClientCount(res?.data?.totalSubClients);
        setNumbersCount(res?.data?.totalNumbers);
        setMessageCount(res?.data?.totalMessages);
        setIsLoading(false);
      }, 1000);
    };

    setIsLoading(true);
    const result = await callApi(
      "GET",
      `${routes.appStats}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  useEffect(() => {
    getAppStats();
  }, []);

  return (
    <div className="dashboard-main-container">
      <main className="content">
        <div className="welcome-message">
          <h1 className="welcome-heading">Welcome to the Dashboard!</h1>
          <p className="welcome-subtext">
            Overview of your platform's key metrics
          </p>
        </div>

        {isLoading ? (
          <div style={{ textAlign: "center", marginTop: "50px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Row gutter={16} className="stats-row">
            <Col span={6}>
              <Card>
                <UserOutlined style={{ fontSize: "48px", color: "#3f8600" }} />
                <Statistic
                  title="Total Clients"
                  value={clientCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <SmileOutlined style={{ fontSize: "48px", color: "#3f8600" }} />
                <Statistic
                  title="Total Sub Clients"
                  value={subClientCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <BookOutlined style={{ fontSize: "48px", color: "#3f8600" }} />
                <Statistic
                  title="Total Numbers"
                  value={numbersCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <VideoCameraOutlined
                  style={{ fontSize: "48px", color: "#3f8600" }}
                />
                <Statistic
                  title="Total Messages"
                  value={messageCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
          </Row>
        )}
      </main>

      <footer className="footer">
        <p className="footer-text">
          © 2025 INTERACT GLOBAL. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Dashboard;
